export default "__VITE_ASSET__Ce5MZzX2__"